import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import application from './application'
import admin from './admin'
import jury from './jury'
import schedule from './schedule'
import moment from 'moment'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    application,
    admin,
    jury,
    schedule
  },
  state: {
    error: '',
    message: '',
    applicationLaunchDate: '2025-11-20T22:00Z',
    applicationTlEndDate: '2026-01-13T22:00Z',
    applicationEndDate: '2026-02-10T22:00Z',
    juryDeadline: '2026-04-25T22:00Z',
    acceptanceDate: '2026-05-01T22:00Z',
    confirmationDeadline: '2026-06-16T22:00Z',
    schedulesOutDate: '2026-07-03T22:00Z',
    juryReleaseDate: '2026-03-13T22:00Z'
  },
  getters: {
    isError: (state) => {
      return state.error.length > 0
    },
    isMessage: (state) => {
      return state.message.length > 0
    },
    isAfterLaunchDate: (state) => {
      return moment().tz('UTC').isAfter(state.applicationLaunchDate)
    },
    isAfterDeadline: (state) => {
      return moment().tz('UTC').isAfter(state.applicationEndDate)
    },
    isBeforeDeadline: (state) => {
      return moment().tz('UTC').isBefore(state.applicationEndDate)
    },
    pastTLAppDeadline: (state) => {
      return moment().tz('UTC').isAfter(state.applicationTlEndDate)
    },
    isAfterSchedulesOut: (state) => {
      return moment().tz('UTC').isAfter(state.schedulesOutDate)
    },
    isAfterJuryReleased: (state) => {
      return moment().tz('UTC').isAfter(state.juryReleaseDate)
    },
    isAfterConfirmationDeadline: (state) => {
      return moment().tz('UTC').isAfter(state.confirmationDeadline)
    },
    isAfterDecisionsOut: (state) => {
      return moment().tz('UTC').isAfter(state.acceptanceDate)
    }
  },
  mutations: {
    error (state, { message }) {
      if (message === 'Failed to fetch') {
        state.error = 'Unable to complete request. If this continues to persist, email sv-s2026@siggraph.org'
      } else {
        state.error = message
      }
    },
    clearError (state) {
      state.error = ''
    },
    message (state, { message }) {
      state.message = message
    },
    clearMessage (state) {
      state.message = ''
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js